import type { StudentApiResponse } from '@/domains/students/student.entity';
import type { StudentRepository } from '@/domains/students/student.repository';
import { studentApiService } from '../http/student.api';

/**
 * Implementación del repositorio de datos de estudiantes usando la nueva interfaz granular
 * Cumple con ISP - Interface Segregation Principle
 */
class StudentApiRepository implements StudentRepository {
  /**
   * Servicio para obtener lista completa de estudiantes
   */
  async getAllStudents(): Promise<StudentApiResponse> {
    const response = await studentApiService.getStudentAll();

    if (!response) throw new Error('Error al obtener la lista de estudiantes');

    return response;
  }
}

export const studentApiRepository = new StudentApiRepository();
